/**
 * ч.958 (рішення власника, дизайн зі скріна): ОБЛІКОВИЙ ЗАПИС — повноцінна
 * сторінка замість попапа у хідері. Ліворуч — список розділів (біла картка),
 * праворуч — вміст обраного розділу.
 *
 * Розділи і права:
 *  • «Облікові дані», «Oblik+/AI», «Підписка і оплата», «Сховище»,
 *    «Передача прав», «Видалити акаунт» — доступні КОЖНОМУ (свій акаунт);
 *  • «Адміністрування бізнес-акаунта» — admin.access.manage;
 *  • «Майстер міграції» / «Історія міграцій» — admin.migration.run.
 * Розділ, на який немає права, не показується у списку і не відкривається
 * прямим URL (див. AccountPage).
 */
import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

export interface AccountSectionDef {
  /** сегмент URL: /account/<key> ('' — перший розділ, /account) */
  key: string;
  label: string;
  /** Потрібне право (null — доступно всім). */
  permission: string | null;
  element: ReactNode;
}

export default function AccountLayout({ sections, activeKey }: {
  sections: AccountSectionDef[];
  activeKey: string;
}) {
  const active = sections.find((s) => s.key === activeKey) ?? sections[0];
  return (
    <div className="account">
      <nav className="account__nav card">
        {sections.map((s) => (
          <NavLink key={s.key || 'root'}
            to={s.key ? `/account/${s.key}` : '/account'}
            end={!s.key}
            className={`account__nav-item${active?.key === s.key ? ' is-active' : ''}`}>
            {s.label}
          </NavLink>
        ))}
      </nav>
      <div className="account__body">{active?.element}</div>
    </div>
  );
}
